import * as React from "react";
import styled from "@mui/material/styles/styled";
import ClinicalReasoningIconSVG from "../../../assets/clinicalReasoningIcon.svg";
import { HideClinicalReasoningIcon } from "../nextStep/NextStepPanel";
import { IconButton } from "@mui/material";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { useFindingClinicalReason } from "../refineFeature/useFindingClinicalReason";
import { Suggestion } from "../hooks/useSuggestions";
import { Qualifier } from "fe-common/graphql";

//region [[ Styles ]]

const ClinicalReasoningIconMobileView = styled("div")(({ theme }) => ({
  marginRight: "8px",
  marginLeft: "0px",
}));

const ShowClinicalReasoning = styled(IconButton)(({ theme }) => ({
  display: "flex",
  cursor: "pointer",
  paddingLeft: "3px",
  padding: "2px",
  fontWeight: 500,
  color: RosebudColorMap.green2,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicalReasoningIconMobileProps {
  showClinicalReasoning: boolean;
  onShowClinicalReasoning: () => void;
  suggestion?: Suggestion;
  qualifier?: Qualifier;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicalReasoningIconMobile = ({
  ...props
}: ClinicalReasoningIconMobileProps) => {
  const diseasesStrength = useFindingClinicalReason(
    props.suggestion?.causedByDisease,
  )(props.qualifier ? props.qualifier : null);

  if (!diseasesStrength || diseasesStrength.length === 0) {
    return <></>;
  }

  return (
    <ClinicalReasoningIconMobileView>
      <ShowClinicalReasoning onClick={props.onShowClinicalReasoning}>
        {props.showClinicalReasoning ? (
          <HideClinicalReasoningIcon />
        ) : (
          <img src={ClinicalReasoningIconSVG} alt={"clinicalReasoning"} />
        )}
      </ShowClinicalReasoning>
    </ClinicalReasoningIconMobileView>
  );
};
